import { UpgradeToPremium } from 'assets';
import Image from 'next/image';
import React from 'react';

const HeroSection = () => {
  return (
    <div className='px-4 relative md:h-[380px] h-[320px] flex flex-col items-center justify-center bg-subscription-bg md:bg-cover bg-inherit bg-center'>
      <div
        style={{
          background: `linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%), linear-gradient(180deg, rgba(18,18,18,0.9) 0%, var(--black-shades-100, #000) 100%)`,
        }}
        className='absolute top-0 left-0 w-full h-full z-10'
      ></div>
      <Image
        className='md:w-[170px] w-[145px] h-auto md:mb-5 mb-4 z-20'
        src={UpgradeToPremium}
        alt='UpgradeToPremium'
        width={170}
        height={120}
      />
      <h1 className='md:text-[32px] text-xl md:leading-[40px] leading-7 text-white font-semibold text-center max-w-xl md:mb-3 mb-2 z-20'>
        Become a ZebraLearn Member for the Best Learning Experience
      </h1>
      <p className='md:text-lg text-sm font-normal text-grayZl-500 z-20 text-center'>
        Get 1 credit a month to use on any title you like
      </p>
    </div>
  );
};

export default HeroSection;
